import { z } from "zod";

/*
 * The vocabulary of drafting switches: which levels exist and which states each can hold. Pure, so
 * the browser reads it as well as the server. The rule, the store and the SQL mirror are in
 * `drafting-switches.ts`.
 */

export const DraftingLevelSchema = z.enum(["workspace", "campaign", "lead"]);
export type DraftingLevel = z.infer<typeof DraftingLevelSchema>;
export const WorkspaceDraftingSchema = z.enum(["on", "off"]);
export const ScopedDraftingSchema = z.enum(["on", "off", "inherit"]);
export type WorkspaceDrafting = z.infer<typeof WorkspaceDraftingSchema>;
export type ScopedDrafting = z.infer<typeof ScopedDraftingSchema>;
